var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("settings"),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.classes,
          style: _vm.styles,
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.selectItem($event)
            }
          }
        },
        [
          _vm.showButtons
            ? _c(
                "div",
                {
                  staticClass: "item-buttons",
                  class: _vm.controlsClass,
                  style: _vm.controlsStyle
                },
                [
                  !_vm.hideSort
                    ? _c("i", {
                        staticClass: "fas fa-sort-up mdb-icon-btn edit",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.moveItem(_vm.direction.up)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideDelete
                    ? _c("i", {
                        staticClass: "fa fa-times mdb-icon-btn delete",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.deleteItem($event)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideSort
                    ? _c("i", {
                        staticClass: "fas fa-sort-down mdb-icon-btn edit",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.moveItem(_vm.direction.down)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.locked
                    ? _c("i", {
                        staticClass: "fas fa-lock-open mdb-icon-btn edit",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$emit("lock-item", true)
                          }
                        }
                      })
                    : _c("i", {
                        staticClass: "fas fa-lock mdb-icon-btn new",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$emit("lock-item", false)
                          }
                        }
                      })
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "item-buttons",
                  class: _vm.controlsClass,
                  style: _vm.controlsStyle
                },
                [
                  _vm.lockedByParent
                    ? _c("i", { staticClass: "locked-item fas fa-lock" })
                    : _vm.parentId !== null
                    ? _c("i", { staticClass: "unlocked-item fas fa-lock-open" })
                    : _vm._e()
                ]
              ),
          _vm._v(" "),
          _c("div", [_vm._t("default")], 2)
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }